// material ui icons
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';

// material ui
import { Box, Button, IconButton, Tooltip } from '@mui/material';

// relative
import { useUserMenuState } from '../components/appbar/user-menu/useUserMenuState';

interface NavigationFooterActionsProps {
  drawerOpen: boolean;
  onOpenCookiePreferences: () => void;
}

export default function NavigationFooterActions({
  drawerOpen,
}: NavigationFooterActionsProps) {
  const { t, handleLogout } = useUserMenuState();

  if (drawerOpen) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
          alignItems: 'center',
        }}
      >
        <Button
          onClick={handleLogout}
          startIcon={<LogoutRoundedIcon fontSize="small" />}
          data-testid="nav-footer-logout"
          size="small"
          fullWidth
          sx={{
            justifyContent: 'center',
            color: 'text.secondary',
            ':hover': { color: 'error.main' },
          }}
        >
          {t('toolbar.logout')}
        </Button>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
      }}
    >
      {/* <Tooltip
        title={t('toolbar.cookiePreferences', {
          defaultValue: 'Cookie preferences',
        })}
      >
        <IconButton
          onClick={onOpenCookiePreferences}
          size="small"
          data-testid="nav-footer-cookie-preferences"
        >
          <CookieOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip> */}

      <Tooltip title={t('toolbar.logout')}>
        <IconButton
          onClick={handleLogout}
          data-testid="nav-footer-logout"
          sx={{ ':hover': { color: 'error.main' } }}
        >
          <LogoutRoundedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
